// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8a0WN","topBackground":"styles_topBackground__Vgq7a","bottomBackground":"styles_bottomBackground__u+57U"};